import { forwardRef } from "react";

import Badge from "@mui/material/Badge";
import { SxProps, Theme } from "@mui/material/styles";

import { BadgeProps } from "./types";

export const DashboardBadge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ children, badgeContent, variant, vibe = "brand", anchorOrigin, sx }, ref) => {
    return (
      <Badge
        badgeContent={badgeContent}
        variant={variant}
        ref={ref}
        anchorOrigin={anchorOrigin}
        sx={sx}
        slotProps={{
          badge: {
            sx: (theme: Theme) => ({
              ...theme.typography.caption,
              color: theme.palette.text.reverse.intense,
              fill: theme.palette.text.reverse.intense,
              backgroundColor: theme.palette.surface[vibe].intense,
              width: "unset",
              height: "unset",
              minWidth: 16,
              minHeight: 16,
              padding: theme.spacing(0, 0.5),
              ...(variant === "dot" && {
                width: 8,
                height: 8,
                minWidth: 8,
                minHeight: 8,
                padding: 0,
              }),
            }),
          } as { sx: SxProps<Theme> },
        }}
      >
        {children}
      </Badge>
    );
  }
);

DashboardBadge.displayName = "DashboardBadge";
